var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.params.value)?_c('span',[_vm._v(_vm._s(_vm.params.value.deliveryman.code + ' - ' + _vm.params.value.first_name + ' ' + _vm.params.value.last_name))]):_c('span',[_vm._v(" N/A ")])])}
var staticRenderFns = []

export { render, staticRenderFns }